import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=47ef8e24&scoped=true&"
import script from "./PopupMenu.vue?vue&type=script&lang=js&"
export * from "./PopupMenu.vue?vue&type=script&lang=js&"
import style0 from "./PopupMenu.vue?vue&type=style&index=0&id=47ef8e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef8e24",
  null
  
)

export default component.exports